import { Component, computed, input, viewChild } from '@angular/core';
import { Url } from '@app/models/global.model';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { ContentSectionComponent } from '@app/components/content-section/content-section.component';
import { TeaserComponent } from '@app/components/teaser/teaser.component';
import { PrerolloutOverlayComponent } from '@app/components/product/prerollout-overlay/prerollout-overlay.component';

@Component({
  selector: 'mobi-product-how-to-proceed',
  templateUrl: './product-how-to-proceed.component.html',
  styleUrls: ['./product-how-to-proceed.component.scss'],
  standalone: true,
  imports: [
    EntitySharedModule,
    ContentSectionComponent,
    TeaserComponent,
    PrerolloutOverlayComponent,
  ],
})
export class ProductHowToProceedComponent {
  readonly calculatorCta = input<Url>();
  readonly calculatorCtaTitle = input<string>();
  readonly calculatorCtaDescription = input<string>();
  readonly consultationCta = input<Url>();
  readonly consultationCtaTitle = input<string>();
  readonly consultationCtaDescription = input<string>();
  readonly calculatorCtaPrer = input<Url>();
  readonly nodeId = input<string>();

  readonly prerolloutOverlay = viewChild<PrerolloutOverlayComponent>('prerolloutOverlay');

  /** Whether the prerollout check overlay should be shown instead of direct navigation */
  readonly hasPrerollout = computed(() =>
    Boolean(this.calculatorCtaPrer() && this.nodeId())
  );

  onCalculatorCtaClick(event: MouseEvent): void {
    if (this.hasPrerollout()) {
      event.preventDefault();
      event.stopPropagation();
      this.prerolloutOverlay()?.openOverlay();
    }
  }
}
